import { EmailField } from '@/components/form/fields/text/EmailInput';
import { TextField } from '@/components/form/fields/text/TextInput';

import { FunctionComponent } from 'react';
import { z } from 'zod';

export const SignerInfo = z.object({
  email: z.string().email('Invalid email'),
  name: z.string(),
  position: z.string()
});

export type SignerInfo = z.infer<typeof SignerInfo>;

interface SignTermsAndConditionsStepProps {}

const SignTermsAndConditionsStep: FunctionComponent<SignTermsAndConditionsStepProps> = () => {
  return (
    <div className="space-y-2">
      <p>To proceed, you must be authorised to sign documents for your business.</p>
      <p>Please confirm the following details to begin the Docusign process.</p>
      <div className="flex flex-row space-x-5">
        <TextField className="flex-1" id="signerInfo.name" label="Authorised signatory name" />
        <TextField className="flex-1" id="signerInfo.position" label="Authorised signatory position" />
      </div>
      <EmailField id="signerInfo.email" label="Authorised signatory email" />
    </div>
  );
};

export default SignTermsAndConditionsStep;
